<template>
  <div class="touzibaogao-page">
    <div style="display: none;" @click="runAudio">隐藏播放音频按钮</div>

    <div class="content">
      <div class="content-box" ref="scrollContainer">
        <!-- 此处为投资报告的内容 -->
        <!-- <MarkdownRenderer :content="reportContent" /> -->
        <moban ref="moban" :content="reportContent"></moban>
      </div>
    </div>

    <div class="footer">
      <button class="secondary" @click="handleReset">
        重新调整权重
        <i class="el-icon-refresh"></i>
      </button>
      <button class="secondary" @click="handleBack">
        返回首页
        <i class="el-icon-right"></i>
      </button>
      <button class="next-btn common-btn" id="btn-back-home" @click="handleExport">
        <i class="el-icon-download"></i>
        下载报告

      </button>

    </div>

    <!-- 报告查看二维码弹窗 -->
    <el-dialog title="报告已生成" :visible.sync="qrDialogVisible" width="380px" :close-on-click-modal="false"
               class="qr-dialog" @closed="handleQrDialogClosed">
      <div class="qr-body">
        <p class="qr-tip">扫描下方二维码查看完整报告</p>
        <div class="qr-code-wrapper">
          <!-- 二维码图片（始终占据空间，避免 CLS） -->
          <img v-if="qrCodeUrl" :src="qrDataUrl" alt="报告二维码" class="qr-code-img"
               :class="{ 'qr-img-visible': !qrLoading && qrCodeUrl }" @load="onQrImgLoad" @error="onQrImgError">
          <!-- 骨架屏（与二维码同尺寸同位置，交叉淡入淡出） -->
          <div v-if="showQrSkeleton" class="qr-skeleton" :class="{ 'qr-skeleton-fadeout': qrSkeletonFading }">
            <div class="qr-skeleton-grid">
              <span v-for="n in 9" :key="n" class="qr-skeleton-cell"></span>
            </div>
            <div class="qr-skeleton-spinner">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
              </svg>
            </div>
            <p class="qr-skeleton-hint">二维码生成中</p>
          </div>
          <!-- 空状态占位 -->
          <svg v-if="!qrLoading && !qrCodeUrl" class="qr-placeholder-icon" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
          </svg>
        </div>
      </div>
      <span slot="footer" class="qr-footer">
        <el-button @click="qrDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import MarkdownRenderer from '@/components/MarkdownRenderer.vue'
import moban from './moban.vue'
import { httpUpload } from '@/utils/requestEx'
import QRCode from 'qrcode'
export default {
  name: 'touzibaogao',
  components: {
    // MarkdownRenderer,
    moban
  },
  data () {
    return {
      reportContent: '',
      qrDialogVisible: false,
      qrCodeUrl: '',
      qrDataUrl: '',
      qrLoading: false,
      qrError: false,
      showQrSkeleton: false,
      qrSkeletonFading: false,
      qrSkeletonTimer: null,
      syncChannel: null,
      scrollRafId: null,
      remoteApplyTime: 0,
      lastSentRatio: -1
    }
  },
  computed: {
    truncatedUrl () {
      if (!this.qrCodeUrl) return ''
      return this.qrCodeUrl.length > 50
        ? this.qrCodeUrl.substring(0, 47) + '...'
        : this.qrCodeUrl
    },
    isUrlTruncated () {
      return this.qrCodeUrl && this.qrCodeUrl.length > 50
    }
  },
  watch: {
    qrCodeUrl (newVal) {
      if (newVal) {
        this.generateQr(newVal)
      }
    }
  },
  created () {
    this.runAudio()
    let tzbg = localStorage.getItem('TZBG') || ''
    this.reportContent = tzbg
  },
  mounted () {
    this.initScrollSync()
    window.addEventListener('storage', this.handleStorageChange)
  },
  beforeDestroy () {
    this.destroyScrollSync()
    window.removeEventListener('storage', this.handleStorageChange)
    if (this.qrSkeletonTimer) { clearTimeout(this.qrSkeletonTimer); this.qrSkeletonTimer = null }
  },
  methods: {
    // 播放音频
    runAudio () {
      this.playOnceAudio('/报告生成成功，您可下载报告结果.mp3')
    },
    /* ---- 主副屏滚动同步（content-box 容器） ---- */
    initScrollSync () {
      try {
        this.syncChannel = new BroadcastChannel('touzibaogao-content-scroll-sync')
        this.syncChannel.onmessage = (e) => {
          const msg = e.data
          if (!msg || msg.type !== 'scroll') return
          // 无条件接收最新滚动位置
          this.applyRemoteScroll(msg.ratio)
        }
      } catch (err) {
        console.warn('【投顾报告】BroadcastChannel 初始化失败:', err.message)
      }
      this._onScroll = this.handleScroll.bind(this)
      this.$nextTick(() => {
        const el = this.$refs.scrollContainer
        if (el) el.addEventListener('scroll', this._onScroll, { passive: true })
      })
    },
    destroyScrollSync () {
      if (this.scrollRafId) {
        cancelAnimationFrame(this.scrollRafId)
        this.scrollRafId = null
      }
      const el = this.$refs.scrollContainer
      if (el && this._onScroll) {
        el.removeEventListener('scroll', this._onScroll)
        this._onScroll = null
      }
      if (this.syncChannel) {
        this.syncChannel.close()
        this.syncChannel = null
      }
    },

    /* ---- 主副屏二维码弹窗同步 ---- */
    handleStorageChange (event) {
      if (event.key === 'touzibaogao_qr' && event.newValue) {
        try {
          const data = JSON.parse(event.newValue)
          if (data && data.closed) {
            // 主屏关闭弹窗 → 副屏也关闭
            this.qrDialogVisible = false
            this.qrCodeUrl = ''
            this.qrLoading = false
            this.qrError = false
            this.showQrSkeleton = false
            this.qrSkeletonFading = false
            if (this.qrSkeletonTimer) { clearTimeout(this.qrSkeletonTimer); this.qrSkeletonTimer = null }
          } else if (data && data.action === 'start') {
            // 主屏开始生成 → 副屏显示骨架屏
            this.qrDialogVisible = true
            this.qrCodeUrl = data.url || ''
            this.qrLoading = true
            this.qrError = false
            this.showQrSkeleton = true
            this.qrSkeletonFading = false
          } else if (data && data.url) {
            // 副屏收到主屏上传完成的 URL，设置后 watch 自动生成本地二维码
            this.qrCodeUrl = data.url
            this.qrError = false
          }
        } catch (e) { /* ignore */ }
      }
    },

    handleScroll () {
      if (this.scrollRafId) return
      this.scrollRafId = requestAnimationFrame(() => {
        this.scrollRafId = null
        if (!this.syncChannel) return
        // 时间戳防抖：刚应用远程滚动 200ms 内不广播，阻断反馈循环
        if (Date.now() - this.remoteApplyTime < 200) return
        const el = this.$refs.scrollContainer
        if (!el) return
        const maxScroll = el.scrollHeight - el.clientHeight
        if (maxScroll <= 0) return
        const ratio = el.scrollTop / maxScroll
        // 跳过重复比例，避免无意义广播
        if (Math.abs(ratio - this.lastSentRatio) < 0.002) return
        this.lastSentRatio = ratio
        this.syncChannel.postMessage({ type: 'scroll', ratio })
      })
    },
    applyRemoteScroll (ratio) {
      this.remoteApplyTime = Date.now()
      const el = this.$refs.scrollContainer
      if (!el) return
      const maxScroll = el.scrollHeight - el.clientHeight
      if (maxScroll <= 0) return
      const target = Math.round(ratio * maxScroll)
      // 阈值：位置变化 < 3px 跳过，避免微抖动
      if (Math.abs(el.scrollTop - target) < 3) return
      el.scrollTop = target
    },

    handleReset () {
      // 重新调整权重
      this.$router.push({ name: 'Tiaozhengzichanbili' })
    },
    //测试音频是否被屏蔽
    checkAudioStatus () {
      const audios = document.querySelectorAll('audio');
      if (audios.length === 0) {
        console.log('✅ 检测结果：页面中没有任何 <audio> 元素（或已被完全移除）');
        return;
      }
      let blockedCount = 0;
      audios.forEach((audio, index) => {
        const isMuted = audio.muted;
        const isVolZero = audio.volume === 0;
        const isPaused = audio.paused;
        const hasError = audio.error !== null;
        const isHidden = audio.offsetParent === null;
        const hasSrc = audio.src || audio.currentSrc;
        // 判定为“被屏蔽”的标准（综合判断）
        const isBlocked = isMuted || isVolZero || hasError || !hasSrc;
        // 记录详情
        console.log(`🎵 音频 #${index}:`, {
          src: audio.src || '无',
          muted: isMuted,
          volume: audio.volume,
          paused: isPaused,
          hasError: hasError,
          errorCode: audio.error?.code || '无',
          isHidden: isHidden,
          isBlocked: isBlocked
        });
        if (isBlocked) blockedCount++;
      });
      console.log(`📊 总计: ${audios.length} 个音频，其中 ${blockedCount} 个处于屏蔽/静音/错误状态`);
    },
    handleExport () {
      document.querySelectorAll('audio').forEach(a => { a.pause(); a.src = ''; a.remove() })
      this.checkAudioStatus()
      this.$refs.moban.generatePdfBlob().then(pdfBlob => {
        const formData = new FormData()
        formData.append('file', pdfBlob, '投顾建议报告.pdf')
        httpUpload('/api/open/portfolio/reports/upload', formData).then(res => {
          console.log('上传PDF返回结果：', res)
          const url = res?.data?.url || res?.url
          if (url) {
            this.showQrDialog(url)
          } else {
            this.$message.success('报告已上传')
          }
        }).catch(err => {
          console.error('上传PDF失败：', err)
          this.$message.warning('报告上传失败，但PDF已保存到本地')
        })
      }).catch(err => {
        console.error('PDF生成失败:', err)
        this.$message.error('PDF生成失败，请重试')
      })
    },
    showQrDialog (url) {
      this.qrCodeUrl = url
      this.qrDialogVisible = true
      this.qrLoading = true
      this.qrError = false
      this.showQrSkeleton = true
      this.qrSkeletonFading = false
      // 同步副屏：开始生成 + URL
      localStorage.setItem('touzibaogao_qr', JSON.stringify({ action: 'start', url, timestamp: Date.now() }))
    },
    generateQr (url) {
      QRCode.toDataURL(url, { width: 240, margin: 1 })
        .then(dataUrl => {
          this.qrDataUrl = dataUrl
          this.qrLoading = false
          if (this.qrSkeletonTimer) clearTimeout(this.qrSkeletonTimer)
          this.qrSkeletonFading = true
          this.qrSkeletonTimer = setTimeout(() => {
            this.showQrSkeleton = false
            this.qrSkeletonFading = false
            this.qrSkeletonTimer = null
          }, 420)
        })
        .catch(() => {
          this.qrLoading = false
          this.showQrSkeleton = false
          this.qrSkeletonFading = false
          this.qrError = true
        })
    },
    onQrImgLoad () {
      // 先触发骨架屏淡出
      this.qrSkeletonFading = true
      this.qrLoading = false
      // 骨架屏淡出动画完成后（0.4s）移除 DOM，避免 CLS
      if (this.qrSkeletonTimer) clearTimeout(this.qrSkeletonTimer)
      this.qrSkeletonTimer = setTimeout(() => {
        this.showQrSkeleton = false
        this.qrSkeletonFading = false
        this.qrSkeletonTimer = null
      }, 420)
    },
    onQrImgError () {
      this.qrLoading = false
      this.qrError = true
      this.showQrSkeleton = false
      this.qrSkeletonFading = false
      if (this.qrSkeletonTimer) { clearTimeout(this.qrSkeletonTimer); this.qrSkeletonTimer = null }
    },
    handleCopyUrl () {
      if (!this.qrCodeUrl) return
      // 使用 Clipboard API 复制
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.qrCodeUrl).then(() => {
          this.$message.success('链接已复制到剪贴板')
        }).catch(() => {
          this.fallbackCopy()
        })
      } else {
        this.fallbackCopy()
      }
    },
    fallbackCopy () {
      const textarea = document.createElement('textarea')
      textarea.value = this.qrCodeUrl
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      try {
        document.execCommand('copy')
        this.$message.success('链接已复制到剪贴板')
      } catch (e) {
        this.$message.error('复制失败，请手动复制')
      }
      document.body.removeChild(textarea)
    },
    handleOpenReport () {
      if (this.qrCodeUrl) {
        window.open(this.qrCodeUrl, '_blank')
      }
    },
    handleQrDialogClosed () {
      // 关闭弹窗时重置状态
      this.qrCodeUrl = ''
      this.qrDataUrl = ''
      this.qrLoading = false
      this.qrError = false
      this.showQrSkeleton = false
      this.qrSkeletonFading = false
      if (this.qrSkeletonTimer) { clearTimeout(this.qrSkeletonTimer); this.qrSkeletonTimer = null }
      // 通知副屏关闭弹窗
      localStorage.setItem('touzibaogao_qr', JSON.stringify({ closed: true, timestamp: Date.now() }))
    },
    handleBack () {
      //去除所有缓存
      localStorage.clear()
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style scoped lang="less">
.touzibaogao-page {
  min-height: 100vh;
  // background: linear-gradient(135deg, #f0f4ff 0%, #e8f0ff 50%, #f5f0ff 100%);
  background: url('../../assets/bg-hp.png') no-repeat;
  background-size: 100% 100%;
  padding: 30px 80px;
}

.header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 12px;
}

.logo i {
  font-size: 32px;
  color: #3b82f6;
}

.logo h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.icon {
  width: 36px;
  height: 36px;
  background: #486dff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
    object-fit: cover;
  }
}

.time {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 12px;
}

.content {
  margin-bottom: 15px;
  height: 90vh;

}

.content-box {
  height: 100%;
  overflow: auto;
}

.footer {
  display: flex;
  justify-content: center;
  gap: 16px;
}

.footer .primary {
  height: 50px;
  min-width: 180px;
  padding: 0 28px;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(135deg, #176dff, #604dff);
  box-shadow: 0 12px 24px rgba(45, 119, 255, 0.28);
  transition: all 0.3s ease;
}

.footer .primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 32px rgba(45, 119, 255, 0.38);
}

.footer .secondary {
  height: 50px;
  min-width: 180px;
  padding: 0 28px;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  color: #246bff;
  background: #fff;
  border: 1px solid #bcd0ff;
  transition: all 0.3s ease;
}

.footer .secondary:hover {
  transform: translateY(-2px);
  border-color: #246bff;
  box-shadow: 0 8px 20px rgba(45, 119, 255, 0.15);
}

.next-btn {
  width: 240px;
  font-size: 18px;
}

.next-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
}

.reset-btn {
  width: 240px;
  background: #ffffff;
  font-size: 18px;
  color: #64748b;
  margin-right: 20px;
}

.reset-btn:hover {
  transform: translateY(-2px);
}

/* 横屏小尺寸适配 */
@media screen and (orientation: landscape) and (max-width: 1366px) {
  .touzibaogao-page {
    padding: 10px 40px;
  }

  .logo h1 {
    font-size: 28px;
  }

  .logo i {
    font-size: 28px;
  }

  .tabs {
    gap: 16px;
  }

  .tab-btn {
    padding: 10px 28px;
    font-size: 15px;
  }

  .next-btn {
    padding: 12px 36px;
    font-size: 16px;
  }
}

/* 竖屏适配 */
@media screen and (orientation: portrait) {
  .touzibaogao-page {
    // padding: 20px 16px;
    // min-height: 100vh;
    height: 100%;
    overflow: auto;
    // background: linear-gradient(180deg, #f0f4ff 0%, #faf5ff 50%, #f0f9ff 100%);
    background: url('../../assets/bg-sp.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
  }

  .header {
    text-align: center;
    padding-top: 10px;
  }

  .logo {
    flex-direction: column;
    gap: 8px;
    justify-content: center;
  }

  .logo h1 {
    font-size: 18px;
    font-weight: 700;
    color: #1e293b;
    letter-spacing: 0.5px;
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a855f7 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin: 0;
  }

  .logo i {
    font-size: 20px;
    color: #6366f1;
  }

  .time {
    font-size: 12px;
    color: #64748b;
    margin-bottom: 8px;
  }

  .tabs {
    gap: 8px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .tab-btn {
    padding: 10px 18px;
    font-size: 13px;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(99, 102, 241, 0.2);
    color: #64748b;
    transition: all 0.2s ease;
  }

  .tab-btn.active {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
    border-color: #6366f1;
    color: white;
  }

  .content {
    flex: 1;
    // height: auto;
    margin-bottom: 0;
    display: flex;
    flex-direction: column;
  }

  .content-box {
    flex: 1;
    // padding: 20px;
    // border-radius: 16px;
    // box-shadow: 0 8px 24px rgba(99, 102, 241, 0.08);
    // background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
    // border: 1px solid rgba(99, 102, 241, 0.08);
    overflow-y: auto;
  }

  .footer {
    display: none;
    margin-top: 0;
    padding-top: 0;
    flex-direction: column;
    gap: 12px;
  }

  .reset-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
    border: 1px solid #e2e8f0;
    color: #64748b;
    margin-right: 0;
    transition: all 0.2s ease;
  }

  .reset-btn:hover {
    background: #cbd5e1;
    transform: none;
  }

  .footer .primary,
  .footer .secondary {
    width: 100%;
    height: 48px;
    min-width: unset;
    padding: 0 20px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
  }

  .next-btn {
    width: 100%;
    padding: 14px;
    font-size: 15px;
    font-weight: 600;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1 0%, #4f46e5 50%, #7c3aed 100%);
    border: none;
    color: white;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.35);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.5px;
    position: relative;
    overflow: hidden;
  }

  .next-btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s ease;
  }

  .next-btn:hover::before {
    left: 100%;
  }

  .next-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(99, 102, 241, 0.45);
  }
}

/* 小屏幕适配 */
@media (max-width: 768px) {
  .touzibaogao-page {
    padding: 20px 16px;
  }

  .logo h1 {
    font-size: 18px;
  }

  .logo i {
    font-size: 18px;
  }

  .content-box {
    // padding: 20px;
    border-radius: 12px;
  }

  .footer .primary,
  .footer .secondary {
    height: 42px;
    min-width: unset;
    padding: 0 16px;
    font-size: 13px;
    border-radius: 10px;
  }

  .next-btn {
    padding: 8px 20px;
    font-size: 13px;
  }
}
</style>

<style lang="less">
/* ===== 二维码弹窗样式（非 scoped，适配 el-dialog 蒙层） ===== */
.qr-dialog .qr-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
}

.qr-dialog .qr-tip {
  font-size: 14px;
  color: #475569;
  margin: 0;
  transition: color 0.3s;
}

/* ===== 二维码容器 ===== */
.qr-dialog .qr-code-wrapper {
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  position: relative;
}

/* ===== 二维码图片 ===== */
.qr-dialog .qr-code-img {
  width: 200px;
  height: 200px;
  opacity: 0;
  transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity;
}

.qr-dialog .qr-code-img.qr-img-visible {
  opacity: 1;
}

/* ===== 骨架屏 ===== */
.qr-dialog .qr-skeleton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: #f1f5f9;
  border-radius: 8px;
  overflow: hidden;
  transition: opacity 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: opacity;
}

.qr-dialog .qr-skeleton.qr-skeleton-fadeout {
  opacity: 0;
  pointer-events: none;
}

/* 光泽扫过动画 */
.qr-dialog .qr-skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.5) 40%,
      rgba(255, 255, 255, 0.7) 50%,
      rgba(255, 255, 255, 0.5) 60%,
      transparent 100%);
  animation: qr-shimmer 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes qr-shimmer {
  0% {
    left: -150%;
  }

  100% {
    left: 150%;
  }
}

/* 伪二维码网格 */
.qr-dialog .qr-skeleton-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 5px;
  width: 90px;
  height: 90px;
  opacity: 0.5;
}

.qr-dialog .qr-skeleton-cell {
  background: #cbd5e1;
  border-radius: 3px;
  animation: qr-cell-pulse 2s ease-in-out infinite;
}

.qr-dialog .qr-skeleton-cell:nth-child(1) {
  animation-delay: 0s;
}

.qr-dialog .qr-skeleton-cell:nth-child(2) {
  animation-delay: 0.15s;
}

.qr-dialog .qr-skeleton-cell:nth-child(3) {
  animation-delay: 0.3s;
}

.qr-dialog .qr-skeleton-cell:nth-child(4) {
  animation-delay: 0.45s;
}

.qr-dialog .qr-skeleton-cell:nth-child(5) {
  animation-delay: 0.6s;
}

.qr-dialog .qr-skeleton-cell:nth-child(6) {
  animation-delay: 0.75s;
}

.qr-dialog .qr-skeleton-cell:nth-child(7) {
  animation-delay: 0.9s;
}

.qr-dialog .qr-skeleton-cell:nth-child(8) {
  animation-delay: 1.05s;
}

.qr-dialog .qr-skeleton-cell:nth-child(9) {
  animation-delay: 1.2s;
}

@keyframes qr-cell-pulse {

  0%,
  100% {
    opacity: 0.3;
    transform: scale(0.95);
  }

  50% {
    opacity: 0.9;
    transform: scale(1);
  }
}

/* 骨架屏旋转图标 */
.qr-dialog .qr-skeleton-spinner {
  width: 24px;
  height: 24px;
  color: #3b82f6;
  animation: qr-spin 1s linear infinite;
}

@keyframes qr-spin {
  to {
    transform: rotate(360deg);
  }
}

/* 骨架屏提示文字 */
.qr-dialog .qr-skeleton-hint {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  letter-spacing: 0.02em;
}

/* ===== 空状态占位 ===== */
.qr-dialog .qr-placeholder-icon {
  width: 64px;
  height: 64px;
  color: #cbd5e1;
  opacity: 0.5;
}

.qr-dialog .qr-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* ===== 竖屏适配 ===== */
@media screen and (orientation: portrait) {
  .qr-dialog {
    width: 100vw !important;
  }

  .qr-dialog .qr-code-wrapper {
    width: 180px;
    height: 180px;
  }

  .qr-dialog .qr-code-img {
    width: 160px;
    height: 160px;
  }

  .qr-dialog .qr-skeleton {
    width: 160px;
    height: 160px;
  }

  .qr-dialog .qr-skeleton-grid {
    width: 72px;
    height: 72px;
    gap: 4px;
  }

  .qr-dialog .qr-tip {
    font-size: 13px;
  }
}
</style>
